import { persist } from 'zustand/middleware';
import { createStore } from 'zustand/vanilla';

export type InvitationStore = {
  inviteToken?: string;

  // Actions
  setInviteToken: (inviteToken: string) => void;
  clearInviteToken: () => void;
};

export const invitationStore = createStore<InvitationStore>()(
  persist(
    (set) => ({
      inviteToken: undefined,

      setInviteToken: (inviteToken) => set({ inviteToken }),
      clearInviteToken: () => set({ inviteToken: undefined }),
    }),
    { name: 'invitationStore' },
  ),
);

// Selectors
export function setInviteTokenSelector(state: InvitationStore) {
  return state.setInviteToken;
}

export function clearInviteTokenSelector(state: InvitationStore) {
  return state.clearInviteToken;
}

export function inviteTokenSelector(state: InvitationStore) {
  return state.inviteToken;
}
